module.exports = __webpack_public_path__ + "static/media/bookmark.fa618dfe.svg";